import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

const AdminHeader = () => {
    const LogoPrincipal= process.env.REACT_APP_LOGOPRINCIPAL;
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="relative"
        sx={{
          // mt: 'auto',
          backgroundColor: 'var(--primary-color)',
        }}
      >
        <Toolbar sx={{ justifyContent: 'left' }}>
          <img
            style={{height: '40px', width: '200px'}}
            src={LogoPrincipal}
            alt=""
          />
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default AdminHeader;
